export const petroleum = () => {
    return (
        <div>
            <div className="content" readonly=""><h1>Кейс по внедрению 1С в холдинге "Petroleum" – Оптимизация
                бизнес-процессов</h1>

                <h2>Заказчик</h2>
                <p><strong>Холдинг "Petroleum"</strong> (включает компании ТОО "Petroleum", ТОО "ЕРТЫС СЕРВИС", ТОО
                    "Batys Petroleum", РТИ-АНПЗ ТОО, ТОО "КАЗЫКУРТ-ЮГ")</p>

                <h2>Исполнитель</h2>
                <p>ГК "Кибернетика.com"</p>

                <h2>Цель проекта</h2>
                <p>Автоматизация ключевых бизнес-процессов компаний холдинга, повышение эффективности управления
                    документами, кадровым учетом и расчетом заработной платы с использованием программных решений
                    1С.</p>

                <h2>Ключевые задачи и решения</h2>
                <ul>
                    <li><strong>Оптимизация документооборота</strong> – переход с устаревшей системы Lotus на
                        1С:Документооборот 8.
                    </li>
                    <li><strong>Автоматизация управления персоналом и расчета заработной платы</strong> – внедрение
                        1С:Зарплата и управление персоналом 3.1.
                    </li>
                    <li><strong>Интеграция с документооборотом</strong> – сквозная интеграция всех кадровых и
                        управленческих документов.
                    </li>
                    <li><strong>Разработка аналитических отчетов</strong> – создание специализированных отчетов, включая
                        "Расчетную ведомость организации (с расшифровкой)".
                    </li>
                    <li><strong>Интеграция с существующими системами</strong> – механизм загрузки табельного учета из
                        Excel.
                    </li>
                    <li><strong>Контроль дисциплины и учета отсутствий</strong> – мониторинг сотрудников.</li>
                </ul>

                <h2>Автоматизация кадрового учета и расчета заработной платы</h2>
                <ul>
                    <li>Перенос всех кадровых данных из предыдущей системы.</li>
                    <li>Автоматизация расчета заработной платы, налогов и отчислений.</li>
                    <li>Настройка графиков рабочего времени и учета переработок.</li>
                    <li>Создание механизма загрузки данных табельного учета.</li>
                    <li>Интеграция с банковскими системами для автоматизированной выплаты зарплаты.</li>
                    <li>Формирование отчетности в соответствии с законодательством.</li>
                </ul>

                <h2>Проект "Документооборот" – автоматизация сквозных процессов</h2>
                <ul>
                    <li>Перенос всех кадровых данных и документов.</li>
                    <li>Автоматизация процессов согласования документов.</li>
                    <li>Сквозной процесс согласования между компаниями холдинга.</li>
                    <li>Централизованное хранение документов с гибким доступом.</li>
                    <li>Интеграция с кадровым учетом и расчетом зарплаты.</li>
                </ul>

                <h2>Этапы проекта</h2>
                <ul>
                    <li>Обследование и анализ – выявление проблемных зон.</li>
                    <li>Разработка технического задания – детализация требований.</li>
                    <li>Настройка и доработка системы – адаптация решений 1С.</li>
                    <li>Тестирование и обучение сотрудников – подготовка персонала.</li>
                    <li>Запуск и сопровождение – устранение замечаний.</li>
                </ul>

                <h2>Результаты</h2>
                <ul>
                    <li>Время согласования документов сократилось на 40%.</li>
                    <li>Автоматизирован учет кадровых данных и начисление зарплаты.</li>
                    <li>Полный переход с Lotus на 1С:Документооборот.</li>
                    <li>Интеграция с 1С:ЗУП, исключающая дублирование информации.</li>
                    <li>Улучшен контроль исполнительской дисциплины.</li>
                    <li>Снижение времени на расчет зарплаты на 50%.</li>
                    <li>Повышение прозрачности налоговых расчетов.</li>
                </ul>

                <h2>Текущий статус проекта</h2>
                <p>На данный момент проект находится на технической поддержке у ГК "Кибернетика.com". Мы продолжаем
                    сопровождение системы, обеспечивая ее стабильную работу, доработку функционала и поддержку
                    пользователей.</p>

                <h2>Ключевые технологии</h2>
                <ul>
                    <li><strong>Платформа:</strong> 1С:Предприятие 8.</li>
                    <li><strong>Решения:</strong> 1С:Документооборот, 1С:Зарплата и управление персоналом.</li>
                    <li><strong>Интеграции:</strong> учетные и кадровые системы компаний холдинга.</li>
                </ul>

                <h2>Отзыв заказчика</h2>
                <p>Внедренные решения повысили эффективность управления документами, автоматизировали ключевые кадровые
                    процессы и упростили расчет заработной платы. Система гибко адаптируется под текущие и будущие
                    потребности холдинга.</p>

                <h2>Заключение</h2>
                <p>Проект внедрения 1С в холдинг "Petroleum" продемонстрировал значительное улучшение бизнес-процессов.
                    Дальнейшее развитие системы позволит еще больше оптимизировать работу предприятий группы.</p></div>
        </div>
    )
}